export default "//cdn.scentbird.com/assets/frontbird-site/images/dryShampoo_edea3a.png";